import type {
  ApiPagination,
  ApiPaginationNormal,
  ApiPaginationSimplified,
} from "./api-pagination.type";

import { isValidNumber } from "@/utilities/number";

export const isNormalPagination = (
  pagination?: ApiPagination
): pagination is ApiPaginationNormal => {
  if (!pagination?.meta) return false;

  return "total" in pagination.meta && isValidNumber(pagination.meta.total);
};

export const isSimplifiedPagination = (
  pagination?: ApiPagination
): pagination is ApiPaginationSimplified => {
  if (!pagination?.links) return false;

  return pagination.links.last === null;
};

export const getApiPaginationTotal = (pagination?: ApiPagination): number => {
  return isNormalPagination(pagination) ? pagination.meta.total : 0;
};
